module.exports = __webpack_public_path__ + "static/img/1075_big.5d1503d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1075_big.png
// module id = gEMY
// module chunks = 1